import React, { useEffect, useRef } from "react";

function createDrop(width, height) {
  return {
    x: Math.random() * width,
    y: Math.random() * height,
    len: 8 + Math.random() * 16,
    speed: 2 + Math.random() * 4,
    opacity: 0.15 + Math.random() * 0.35,
  };
}

export default function RainOverlay() {
  const canvasRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    const ctx = canvas.getContext("2d");
    if (!ctx) return undefined;

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (prefersReduced.matches) return undefined;

    let width = 0;
    let height = 0;
    let drops = [];
    let dropCount = 0;

    const resize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
      dropCount = Math.max(60, Math.floor((width * height) / 18000));
      drops = Array.from({ length: dropCount }, () => createDrop(width, height));
    };

    const draw = () => {
      ctx.clearRect(0, 0, width, height);
      ctx.lineWidth = 1;
      ctx.lineCap = "round";

      for (let i = 0; i < drops.length; i += 1) {
        const d = drops[i];
        ctx.strokeStyle = `rgba(255, 255, 255, ${d.opacity})`;
        ctx.beginPath();
        ctx.moveTo(d.x, d.y);
        ctx.lineTo(d.x + 1, d.y + d.len);
        ctx.stroke();

        d.y += d.speed;
        if (d.y > height + d.len) {
          drops[i] = createDrop(width, height);
          drops[i].y = -drops[i].len;
        }
      }

      rafRef.current = window.requestAnimationFrame(draw);
    };

    resize();
    draw();
    window.addEventListener("resize", resize);

    return () => {
      window.removeEventListener("resize", resize);
      if (rafRef.current) {
        window.cancelAnimationFrame(rafRef.current);
      }
    };
  }, []);

  return <canvas ref={canvasRef} className="rain-overlay" aria-hidden="true" />;
}
